// JOBE-0106: RecentActivityLane — UI mock per Decision 3 of the spec.
//
// Static placeholder rows. NO fetch. The project-scoped activity feed
// is out of scope until a feed-surface justification exists; the lane
// renders a small "preview" marker so the surface communicates its
// own posture.

import React from 'react';

const PREVIEW_ROWS = [
  { id: 'mock-1', who: 'iris', verb: 'updated the briefing', when: '3h ago' },
  { id: 'mock-2', who: 'shawn', verb: 'added a watcher', when: 'yesterday' },
  { id: 'mock-3', who: 'router', verb: 'closed a task', when: '2d ago' },
];

export function RecentActivityLane() {
  return (
    <div className="project-recent-activity-lane" data-testid="recent-activity-lane">
      <h3 className="lane-title">
        Recent activity
        <span className="lane-preview-marker mono"> · preview</span>
      </h3>
      <ul className="recent-activity-rows">
        {PREVIEW_ROWS.map((r) => (
          <li key={r.id} className="recent-activity-row">
            <span className="mono recent-activity-who">{r.who}</span>
            <span className="recent-activity-verb"> {r.verb}</span>
            <span className="muted recent-activity-when mono"> · {r.when}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
